import { render, staticRenderFns } from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=template&id=2c3ee00e"
import script from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports